"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var windowPadding = 8;

var centerPosition = function centerPosition(_a) {
  var oStart = _a.oStart,
      oLength = _a.oLength,
      uStart = _a.uStart,
      uLength = _a.uLength;
  return Math.round(uStart + uLength / 2 - oLength / 2 - oStart);
};

var getAutoMiddlePosition = function getAutoMiddlePosition(options, autoOverflow, container) {
  if (autoOverflow) {
    var halfOLength = options.oLength / 2;
    var uCenterY = options.uStart + options.uLength / 2;
    var bottomSpace = window.innerHeight - uCenterY;
    var topSpace = uCenterY;
    var minSpace = Math.min(bottomSpace, topSpace);

    if (halfOLength > minSpace) {
      if (bottomSpace > topSpace) {
        if (container) {
          return windowPadding;
        }

        return -options.uStart + windowPadding;
      } else {
        if (container) {
          return window.innerHeight - options.oLength - windowPadding + container.parentElement.scrollTop;
        }

        return -options.uStart + (window.innerHeight - options.oLength) - windowPadding;
      }
    }

    return centerPosition(options);
  }

  return centerPosition(options);
};

var endPosition = function endPosition(_a, align) {
  var oStart = _a.oStart,
      uEnd = _a.uEnd,
      uLength = _a.uLength,
      distance = _a.distance;

  if (align === void 0) {
    align = false;
  }

  return align ? uEnd - oStart - uLength : uEnd + distance - oStart;
};

var startPosition = function startPosition(_a, align) {
  var oStart = _a.oStart,
      oLength = _a.oLength,
      uLength = _a.uLength,
      uStart = _a.uStart,
      distance = _a.distance;

  if (align === void 0) {
    align = false;
  }

  return align ? uStart - oLength - oStart + uLength : uStart - distance - oLength - oStart;
};

exports.adjust = function (placement, domOptions, autoOverflow, container, reservePlacement) {
  if (autoOverflow === void 0) {
    autoOverflow = false;
  } // TODO: добавить reservePlacement для bottom и top


  if (reservePlacement) {
    var underlayRect = domOptions.underlayRect,
        overlayRect = domOptions.overlayRect,
        distance = domOptions.distance;

    switch (true) {
      case placement === 'right' || placement === 'rightTop':
        // Зашли за правую границу экрана
        if (underlayRect.right + distance + overlayRect.width + windowPadding > window.innerWidth) {
          placement = reservePlacement;
        }

        break;

      case placement === 'left' || placement === 'leftTop':
        // Зашли за левую границу экрана
        if (underlayRect.left - distance - overlayRect.width - windowPadding < 0) {
          placement = reservePlacement;
        }

        break;

      case placement === 'bottom' || placement === 'bottomRight':
        // Зашли за нижнюю границу экрана
        if (underlayRect.top + underlayRect.height + distance + overlayRect.height + windowPadding > window.innerHeight) {
          switch (reservePlacement) {
            case 'topLeft':
            case 'topRight':
            case 'top':
              // Если сверху меньше места, то и не будем менять позицию
              if (Math.abs(underlayRect.bottom) <= Math.abs(underlayRect.top - window.innerHeight)) {
                break;
              }

              placement = reservePlacement;

              if (!autoOverflow) {
                break;
              } // Так как стоит autoOverflow, нужно перерасчитать
              // Заного размеры элементов для переноса на вверх


              return {
                top: 0,
                left: 0,
                arrowTop: 0,
                arrowLeft: 0,
                placement: placement,
                needRecalcRect: true
              };

            default:
              placement = reservePlacement;
          }
        }

        break;
    }
  }

  return {
    top: adjustY(placement, domOptions, autoOverflow, container),
    left: adjustX(placement, domOptions),
    arrowTop: adjustArrowY(placement, domOptions),
    arrowLeft: adjustArrowX(placement, domOptions),
    placement: placement
  };
};

function adjustX(placement, _a) {
  var overlayRect = _a.overlayRect,
      underlayRect = _a.underlayRect,
      distance = _a.distance,
      overlayOffset = _a.overlayOffset;
  var options = {
    oStart: overlayRect.left,
    oLength: overlayRect.width,
    oEnd: overlayRect.right,
    uLength: underlayRect.width,
    uStart: underlayRect.left,
    uEnd: underlayRect.right,
    distance: distance
  };

  switch (placement) {
    case 'left':
    case 'leftTop':
      return startPosition(options);

    case 'topLeft':
    case 'bottomLeft':
      return endPosition(options, true) - overlayOffset;

    case 'right':
    case 'rightTop':
      return endPosition(options);

    case 'topRight':
    case 'bottomRight':
      return startPosition(options, true) + overlayOffset;

    default:
      return centerPosition(options);
  }
}

function adjustY(placement, domCalculationOptions, autoOverflow, container) {
  var overlayRect = domCalculationOptions.overlayRect,
      underlayRect = domCalculationOptions.underlayRect,
      distance = domCalculationOptions.distance,
      overlayOffset = domCalculationOptions.overlayOffset;
  var options = {
    oStart: overlayRect.top,
    oLength: overlayRect.height,
    oEnd: overlayRect.bottom,
    uStart: underlayRect.top,
    uLength: underlayRect.height,
    uEnd: underlayRect.bottom,
    distance: distance
  };

  switch (placement) {
    case 'left':
    case 'right':
      return getAutoMiddlePosition(options, autoOverflow, container);

    case 'topLeft':
    case 'topRight':
    case 'top':
      return startPosition(options);

    case 'leftTop':
    case 'rightTop':
      return endPosition(options, true) - overlayOffset;

    default:
      return endPosition(options);
  }
}

function adjustArrowY(placement, _a) {
  var overlayRect = _a.overlayRect,
      underlayRect = _a.underlayRect,
      distance = _a.distance,
      overlayOffset = _a.overlayOffset;

  switch (placement) {
    case 'leftTop':
    case 'rightTop':
      return overlayOffset;

    default:
      return 0;
  }
}

function adjustArrowX(placement, _a) {
  var overlayRect = _a.overlayRect,
      underlayRect = _a.underlayRect,
      distance = _a.distance,
      overlayOffset = _a.overlayOffset;

  switch (placement) {
    case 'topLeft':
    case 'bottomLeft':
      return overlayOffset;

    case 'topRight':
    case 'bottomRight':
      return -overlayOffset || 0;

    default:
      return 0;
  }
}

function _adjustMaxHeight(placement, padding, _a) {
  var underlayRect = _a.underlayRect,
      distance = _a.distance;
  var containerHeight = window.innerHeight;

  switch (placement) {
    case 'leftTop':
    case 'rightTop':
      return containerHeight - padding - underlayRect.top;

    case 'bottom':
    case 'bottomLeft':
    case 'bottomRight':
      return containerHeight - padding - underlayRect.bottom - distance;

    case 'top':
    case 'topLeft':
    case 'topRight':
      return underlayRect.top - padding - distance;

    default:
      return containerHeight - padding * 2;
  }
}

function adjustMaxHeight(placement, options, minHeight) {
  if (!minHeight) {
    return _adjustMaxHeight(placement, windowPadding, options);
  }

  var height = _adjustMaxHeight(placement, windowPadding, options);

  return height <= minHeight ? minHeight - windowPadding : height;
}

exports.adjustMaxHeight = adjustMaxHeight;